// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Rupee$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/entities/currencies/inr/Rupee.mjs";
import * as NextImage$PorterinFeature from "../../../../../../ui/components/NextImage.mjs";
import * as PaymentFailureStore$PorterinFeature from "../store/PaymentFailureStore.mjs";
import * as PaymentFailureModuleScss from "../styles/PaymentFailure.module.scss";

var styles = PaymentFailureModuleScss;

function PaymentFailureCmp(Props) {
  var payment_amount = Props.payment_amount;
  var close_modal = Props.close_modal;
  return React.createElement("div", {
              className: styles["payment-failure-container"]
            }, React.createElement("div", {
                  className: styles.main
                }, React.createElement("div", {
                      className: styles["payment-failure-icon"]
                    }, React.createElement(NextImage$PorterinFeature.make, {
                          src: PaymentFailureStore$PorterinFeature.paymentFailureImgUrl,
                          height: 66.67,
                          width: 66.67,
                          alt: "Error icon"
                        })), React.createElement("div", {
                      className: styles.heading
                    }, PaymentFailureStore$PorterinFeature.paymentFailed), React.createElement("div", {
                      className: styles["sub-heading"]
                    }, PaymentFailureStore$PorterinFeature.packersAndMovers), React.createElement("div", {
                      className: styles["sub-text"]
                    }, PaymentFailureStore$PorterinFeature.bookingAmountToPay), React.createElement("div", {
                      className: styles["payment-amount"]
                    }, Rupee$Catalyst.toCurrencyString(Rupee$Catalyst.fromString(payment_amount))), React.createElement("div", {
                      className: styles["payment-failure-info"]
                    }, React.createElement("span", {
                          className: styles.highlight
                        }, PaymentFailureStore$PorterinFeature.note), PaymentFailureStore$PorterinFeature.paymentFailureDesc)), React.createElement("div", {
                  className: styles.footer
                }, React.createElement("button", {
                      className: styles["footer-cta"],
                      onClick: (function (param) {
                          Curry._1(close_modal, undefined);
                        })
                    }, PaymentFailureStore$PorterinFeature.close)));
}

var make = PaymentFailureCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
